import KeenSlider from "keen-slider";
import "keen-slider/keen-slider.min.css";
import Swiper, { Autoplay, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
/**
 * シリーズトップ画面（オンライン展）の初期化
 */
export function initSampleSeriesWeboothTop() {
    initBannerSlider();
    initSliders();
    initShowAllWeboothProductsAnchors();
    initShowAllWebinarsAnchors();
    //  initPopup();
    //  initTimer();
}
/**
 * バナー用カルーセルの初期化
 */
let bannerSlider = null;
export function initBannerSlider() {
    function navigation(slider) {
        let wrapper;
        let dots;
        let arrowLeft;
        let arrowRight;
        let timerId = null;
        let mouseOver = false;
        function clearNextTimeout() {
            window.clearTimeout(timerId);
            timerId = null;
        }
        function nextTimeout() {
            window.clearTimeout(timerId);
            timerId = null;
            if (mouseOver)
                return;
            timerId = window.setTimeout(() => {
                slider.next();
            }, 3000);
        }
        function markup(remove) {
            wrapperMarkup(remove);
            dotMarkup(remove);
            arrowMarkup(remove);
        }
        function removeElement(element) {
            element.parentNode.removeChild(element);
        }
        function createDiv(className) {
            const div = document.createElement("div");
            const classNames = className.split(" ");
            classNames.forEach((name) => div.classList.add(name));
            return div;
        }
        function arrowMarkup(remove) {
            if (remove) {
                removeElement(arrowLeft);
                removeElement(arrowRight);
                return;
            }
            arrowLeft = createDiv("arrow arrow--left");
            arrowLeft.addEventListener("click", () => slider.prev());
            arrowRight = createDiv("arrow arrow--right");
            arrowRight.addEventListener("click", () => slider.next());
            wrapper.appendChild(arrowLeft);
            wrapper.appendChild(arrowRight);
        }
        function wrapperMarkup(remove) {
            if (remove) {
                const parent = wrapper.parentNode;
                while (wrapper.firstChild)
                    parent.insertBefore(wrapper.firstChild, wrapper);
                removeElement(wrapper);
                return;
            }
            wrapper = createDiv("navigation-wrapper");
            slider.container.parentNode.appendChild(wrapper);
            wrapper.appendChild(slider.container);
        }
        function dotMarkup(remove) {
            if (remove) {
                removeElement(dots);
                return;
            }
            dots = createDiv("dots");
            slider.track.details.slides.forEach((_e, idx) => {
                const dot = createDiv("dot");
                dot.addEventListener("click", () => slider.moveToIdx(idx));
                dots.appendChild(dot);
            });
            wrapper.appendChild(dots);
        }
        function updateClasses() {
            const itemCount = slider.track.details.slides.length;
            if (itemCount <= 1) {
                arrowLeft.classList.add("arrow--disabled");
                arrowRight.classList.add("arrow--disabled");
            }
            else {
                arrowLeft.classList.remove("arrow--disabled");
                arrowRight.classList.remove("arrow--disabled");
            }
            const slide = slider.track.details.rel;
            Array.from(dots.children).forEach(function (dot, idx) {
                idx === slide ? dot.classList.add("dot--active") : dot.classList.remove("dot--active");
            });
        }
        slider.on("created", () => {
            markup(false);
            updateClasses();
            slider.container.addEventListener("mouseover", () => {
                mouseOver = true;
                clearNextTimeout();
            });
            slider.container.addEventListener("mouseout", () => {
                mouseOver = false;
                nextTimeout();
            });
            nextTimeout();
        });
        slider.on("optionsChanged", () => {
            markup(true);
            markup(false);
            updateClasses();
        });
        slider.on("slideChanged", () => {
            updateClasses();
        });
        slider.on("destroyed", () => {
            markup(true);
        });
        slider.on("dragStarted", clearNextTimeout);
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
    }
    const element = document.getElementById("sample-series-webooth-top-banner");
    if (element === null)
        return;
    bannerSlider = new KeenSlider("#" + element.id, {
        loop: true,
        slides: { perView: 1 },
        created: () => {
            element.querySelector('.keen-slider__slide').classList.remove('overflow-unset');
        },
    }, [navigation]);
}
/**
 * カルーセルの初期化
 */
const sliders = [];
const perView = 4;
const timer = 3000;
function initSliders() {
    function navigation(slider) {
        let wrapper;
        let dots;
        let arrowLeft;
        let arrowRight;
        let timerId = null;
        let mouseOver = false;
        function clearNextTimeout() {
            window.clearTimeout(timerId);
            timerId = null;
        }
        function nextTimeout(timer) {
            const scrollToRight = (slider, visibleItemCount) => {
                const itemCount = slider.track.details.slides.length;
                if (itemCount >= visibleItemCount) {
                    const current = slider.track.details.rel;
                    const next = current + 1;
                    if (next % itemCount == 0) {
                        slider.track.to(next % itemCount);
                        //            slider.track.init(next % itemCount);
                        nextTimeout(3000);
                    }
                    else {
                        slider.moveToIdx(next % itemCount, true, { duration: 1000 });
                    }
                }
            };
            window.clearTimeout(timerId);
            timerId = null;
            if (mouseOver)
                return;
            timerId = window.setTimeout(() => {
                scrollToRight(slider, perView);
            }, timer);
        }
        function markup(remove) {
            wrapperMarkup(remove);
            dotMarkup(remove);
            arrowMarkup(remove);
        }
        function removeElement(element) {
            element.parentNode.removeChild(element);
        }
        function createDiv(className) {
            const div = document.createElement("div");
            const classNames = className.split(" ");
            classNames.forEach((name) => div.classList.add(name));
            return div;
        }
        function arrowMarkup(remove) {
            if (remove) {
                removeElement(arrowLeft);
                removeElement(arrowRight);
                return;
            }
            arrowLeft = createDiv("arrow arrow--left");
            arrowLeft.addEventListener("click", () => slider.prev());
            arrowRight = createDiv("arrow arrow--right");
            arrowRight.addEventListener("click", () => slider.next());
            wrapper.appendChild(arrowLeft);
            wrapper.appendChild(arrowRight);
        }
        function wrapperMarkup(remove) {
            if (remove) {
                const parent = wrapper.parentNode;
                while (wrapper.firstChild)
                    parent.insertBefore(wrapper.firstChild, wrapper);
                removeElement(wrapper);
                return;
            }
            wrapper = createDiv("navigation-wrapper");
            slider.container.parentNode.appendChild(wrapper);
            wrapper.appendChild(slider.container);
        }
        function dotMarkup(remove) {
            if (remove) {
                removeElement(dots);
                return;
            }
            dots = createDiv("dots");
            slider.track.details.slides.forEach((_e, idx) => {
                const dot = createDiv("dot");
                dot.addEventListener("click", () => slider.moveToIdx(idx));
                dots.appendChild(dot);
            });
            wrapper.appendChild(dots);
        }
        function updateClasses() {
            const itemCount = slider.track.details.slides.length;
            if (itemCount < perView) {
                arrowLeft.classList.add("arrow--disabled");
                arrowRight.classList.add("arrow--disabled");
            }
            else {
                arrowLeft.classList.remove("arrow--disabled");
                arrowRight.classList.remove("arrow--disabled");
            }
            const slide = slider.track.details.rel;
            Array.from(dots.children).forEach(function (dot, idx) {
                idx === slide ? dot.classList.add("dot--active") : dot.classList.remove("dot--active");
            });
        }
        const popup = document.getElementById("series-top-popup");
        if (popup !== null) {
            popup.addEventListener("mouseout", () => {
                mouseOver = false;
                popup.style.display = "none";
                nextTimeout(timer);
            });
        }
        function initPopup(slider) {
            const elements = slider.container.getElementsByClassName("series-top-popup-cell");
            for (const element of elements) {
                const div = element;
                div.addEventListener("mouseover", (event) => {
                    const article = document.getElementsByTagName("article")[0];
                    //トップーページの位置（画面基準）
                    const offset = article.getBoundingClientRect();
                    //マウスオーバーしている要素の位置（画面基準）
                    const rect = div.getBoundingClientRect();
                    //ポップアップのサイズ
                    const width = rect.width * 2;
                    const height = rect.height * 2;
                    //ポップアップの位置 (トップページ基準)
                    const top = rect.top - offset.top;
                    const left = rect.left - offset.left + width * 0.35;
                    if (popup !== null) {
                        popup.style.display = "block";
                        popup.style.position = "absolute";
                        popup.style.top = `${top}px`;
                        popup.style.left = `${left}px`;
                        popup.style.width = `${width}px`;
                        popup.style.height = `${height}px`;
                        popup.style.zIndex = "99998";
                        popup.innerHTML = div.innerHTML;
                        mouseOver = true;
                        clearNextTimeout();
                        const parent = event.target.closest(".navigation-wrapper");
                        if (parent === null)
                            return;
                        const arrowLeft = parent.querySelector(".arrow--left");
                        if (arrowLeft === null)
                            return;
                        arrowLeft.style.opacity = "0";
                        arrowLeft.style.zIndex = "99999";
                        const arrowRight = parent.querySelector(".arrow--right");
                        if (arrowLeft === null)
                            return;
                        arrowRight.style.opacity = "0";
                        arrowRight.style.zIndex = "99999";
                    }
                });
            }
        }
        slider.on("created", () => {
            markup(false);
            updateClasses();
            initPopup(slider);
            nextTimeout(timer);
        });
        slider.on("optionsChanged", () => {
            markup(true);
            markup(false);
            updateClasses();
        });
        slider.on("slideChanged", () => {
            updateClasses();
        });
        slider.on("destroyed", () => {
            markup(true);
        });
        slider.on("dragStarted", clearNextTimeout);
        slider.on("animationEnded", function () {
            nextTimeout(timer);
        });
        slider.on("updated", function () {
            nextTimeout(timer);
        });
    }
    const elements = document.querySelectorAll('[id^="sample-series-webooth-top-slider"]');
    for (const element of elements) {
        const wrapper = document.querySelector("#" + element.id + " .swiper-wrapper");
        const elementCount = wrapper.children.length;
        if (elementCount > perView) {
            const slider = new Swiper("#" + element.id, {
                modules: [Autoplay, Navigation],
                spaceBetween: 0,
                slidesPerView: perView,
                parallax: true,
                loop: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: "#" + element.id + " .swiper-button-next",
                    prevEl: "#" + element.id + " .swiper-button-prev",
                },
                speed: 800,
            });
            sliders[element.id] = slider;
        }
        else {
            document.querySelector("#" + element.id + " .swiper-button-next").remove();
            document.querySelector("#" + element.id + " .swiper-button-prev").remove();
            const slider = new Swiper("#" + element.id, {
                modules: [Autoplay],
                spaceBetween: 0,
                slidesPerView: perView,
                parallax: true,
                loop: false,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                speed: 800,
            });
            sliders[element.id] = slider;
        }
    }
    initPopup();
}
/**
 * すべて見る（出展ブース）の初期化
 */
function initShowAllWeboothProductsAnchors() {
    const form = document.getElementById("sample-series-webooth-top-webooth-form");
    if (form === null)
        return;
    const submit = (name, value) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
        form.submit();
        form.removeChild(input);
    };
    let elements = document.getElementsByClassName("webooth-form-anchor");
    for (const element of elements) {
        const a = element;
        a.addEventListener("click", () => submit("base-category-id", a.dataset.id));
    }
    elements = document.getElementsByClassName("new-webooth-form-anchor");
    for (const element of elements) {
        const a = element;
        a.addEventListener("click", () => submit("type", a.dataset.type));
    }
    elements = document.getElementsByClassName("recommended-webooth-form-anchor");
    for (const element of elements) {
        const a = element;
        a.addEventListener("click", () => submit("type", a.dataset.type));
    }
}
/**
 * すべて見る（セミナー）の初期化
 */
function initShowAllWebinarsAnchors() {
    const form = document.getElementById("sample-series-webooth-top-webinar-form");
    if (form === null)
        return;
    const elements = document.getElementsByClassName("webinar-form-anchor");
    for (const element of elements) {
        const a = element;
        a.addEventListener("click", () => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "top-course";
            input.value = a.dataset.course ?? "";
            form.appendChild(input);
            form.submit();
            form.removeChild(input);
        });
    }
}
/**
 * ポップアップの初期化
 */
function initPopup() {
    const elements = document.getElementsByClassName("series-top-popup-cell");
    for (const element of elements) {
        const div = element;
        div.addEventListener("mouseover", () => {
            const article = document.getElementsByTagName("article")[0];
            //トップーページの位置（画面基準）
            const offset = article.getBoundingClientRect();
            //マウスオーバーしている要素の位置（画面基準）
            const rect = div.getBoundingClientRect();
            //ポップアップのサイズ
            const width = rect.width * 2;
            const height = rect.height * 2;
            //ポップアップの位置 (トップページ基準)
            const top = rect.top - offset.top;
            const left = rect.left - offset.left + width * 0.35;
            const popup = document.getElementById("series-top-popup");
            if (popup !== null) {
                const sliderId = div.parentElement.parentElement.id;
                const slider = sliders[sliderId];
                slider.autoplay.stop();
                popup.addEventListener("mouseout", () => {
                    popup.style.display = "none";
                    slider.autoplay.start();
                });
                popup.style.display = "block";
                popup.style.position = "absolute";
                popup.style.top = `${top}px`;
                popup.style.left = `${left}px`;
                popup.style.width = `${width}px`;
                popup.style.height = `${height}px`;
                popup.style.zIndex = "99998";
                popup.innerHTML = div.innerHTML;
            }
        });
    }
}
/**
 * タイマーの初期化（カルーセル用）
 */
function initTimer() {
    if (bannerSlider === null && sliders.length === 0)
        return;
    const scrollToRight = (slider, visibleItemCount) => {
        const itemCount = slider.track.details.slides.length;
        if (itemCount > visibleItemCount) {
            const current = slider.track.details.rel;
            const next = current + 1;
            slider.moveToIdx(next % itemCount);
        }
    };
    const startTimer = () => {
        setTimeout(() => {
            if (bannerSlider !== null) {
                scrollToRight(bannerSlider, 1);
            }
            for (const slider of sliders) {
                scrollToRight(slider, perView);
            }
            startTimer();
        }, 3000);
    };
    startTimer();
}
